import { reset } from "redux-form";
import i18next from "i18next";
import { toastr } from "components/toastr";
import { storeReport } from "actions/report.action";
import { isWebview, handleFetchErrors, handleFailedToFetch, getAppVersion } from "helpers";
import { HIDE_POST_SUCCESS } from "actions/post.action";
import { fetchLiveBlind } from "actions/blind.action";
import compareVersions from "compare-versions";
import { isAndroid } from "react-device-detect";

export const reportValidateSubmit = (values, dispatch, props) => {
	if (parseInt(values.report_info_no, 10) === 8 && (!values.comment || values.comment.trim() === "")) {
		toastr.error(i18next.t("기타 사유를 입력해 주세요."), {
			timeOut: 2000,
		});
	} else if (parseInt(values.report_info_no, 10) === 8 && (values.comment.length > 300)) {
		toastr.error(i18next.t("기타 사유는 300자까지 입력할 수 있습니다."), {
			timeOut: 2000,
		});
	} else {
		return storeReport(values)
			.then(handleFetchErrors, handleFailedToFetch)
			.then((response) => response.json())
			.then((response) => {
				response.title_no = values.common_idx;
				dispatch({
					type: HIDE_POST_SUCCESS,
					payload: response,
				});
			})
			.then((response) => {
				if (values.mode !== "page" && props.onClose) {
					// mobile page / pc layer
					props.onClose();
				}
				toastr.success(i18next.t("정상적으로 신고 되었습니다."), {
					timeOut: 2000,
				});
			})
			.catch((error) => {
				if (values.mode !== "page" && props.onClose) {
					// mobile page / pc layer
					props.onClose();
				}
				toastr.error(error.message, {
					timeOut: 2000,
				});
			})
			.finally(() => {
				// 모바일에서만 뒤로 가기
				setTimeout(async () => {
					dispatch(reset(props.form));

					//UGC 대응 문제
					if (values.mode === "page") {
						const version = getAppVersion();
						if (isAndroid && isWebview && compareVersions(version, "6.19.5") >= 0) {

							// LIVE 정보 확인 및 aos func call
							await fetchLiveBlind(values.writer_id);
							/* let url = `/${global.bj_id}/broadInfo/${values.writer_id}`;

							try {
								const response = await axios.get(url);
								let target_broad_no = '';
								let target_id = values.writer_id;
								if(response.data) {
									target_broad_no = response.data.broad_no;
									target_id = response.data.user_id;
								}

								// AOS 웹뷰 function call 
								// window.ReportBridge.reportUgcPolicy(target_id, target_broad_no); // deprecated : 240926 android팀 지오님 요청
								

							} catch (error) {
								
							} finally {
								window.location.href = isWebview ? 'afreeca://browser/close' : DOMAIN_URL;
							} */
						} else {
							if (props.onClose) {
								props.onClose();
							} else {
								// 이전 버전 mobile에서는 back
								props.history.goBack();
							}
						}
					}
				}, 300);
			});
	}
};
